import { TagModel } from '@shared/models/tag.model';
import { City } from '@shared/models/card.model';

export class Image {
  constructor(public url: string, public alt?: string) {}
}

export interface CircuitDifficulty {
  id: number;
  name: string;
}

export const DIFFICULTY_MAPPING = {
  'TRES FACILE': 1,
  FACILE: 2,
  MOYEN: 3,
  DIFFICILE: 4,
};

export class CardList {
  constructor(
    public id: string,
    public old_id: number,
    public category: string,
    public title: string,
    public position: google.maps.LatLngLiteral,
    public idSubcategory: number,
    public circuitType: any,
    public image: Image,
    public city: City,
    public mainTag: TagModel,
    public tags: TagModel[],
    public dateStart: string,
    public dateEnd: string,
    public thematic: string,
    public distance?: number,
    public duration?: number,
    public positiveDenivele?: number,
    public icon?: {
      url: string;
      size: google.maps.Size;
      scaledSize: google.maps.Size;
      anchor: google.maps.Point;
    },
    public kmlPath?: string,
    public isLoop?: boolean,
    public disabledAccess?: boolean,
    public difficulty?: CircuitDifficulty,
    public isCdesi?: boolean,
    public categoryFiltersProducteursLocaux?: ICategoryFiltersProducteurLocaux
  ) {}

  public where(filters: TagModel[]): boolean {
    return filters.some(
      (t) => t.id === this.mainTag?.id || this.tags.some((ct) => ct.id === t.id)
    );
  }
}

export interface ICategoryFiltersProducteurLocaux {
  // V_Cat1	Catégorie Produit - Bovins, caprins, ovins, porcs et autres viandes
  categoryProdcteurLocaux1: number;
  // V_Cat2	Catégorie Produit - Volailles, lapins et produits dérivés
  categoryProdcteurLocaux2: number;
  // V_Cat3	Catégorie Produit - Oeufs
  categoryProdcteurLocaux3: number;
  // V_Cat4	Catégorie Produit - Fromage, lait et produits laitiers
  categoryProdcteurLocaux4: number;
  // V_Cat5	Catégorie Produit - Fruits et légumes
  categoryProdcteurLocaux5: number;
  // V_Cat6	Catégorie Produit - Farines, fruits et légumes secs
  categoryProdcteurLocaux6: number;
  // V_Cat7	Catégorie Produit - Champignons
  categoryProdcteurLocaux7: number;
  // V_Cat8	Catégorie Produit - Epices et huiles
  categoryProdcteurLocaux8: number;
  // V_Cat9	Catégorie Produit - Miel, produits dérivés et confitures
  categoryProdcteurLocaux9: number;
  // V_Cat10	Catégorie Produit - Cidre, bière, jus de fruit et autres boissons
  categoryProdcteurLocaux10: number;
  // V_logo_Ferme
  V_logo_Ferme: number;
  // V_logo_AB:
  V_logo_AB: number;
}

export const mappingProducteur = {
  'bovins, caprins, ovins, porcs et autres viandes': 'categoryProdcteurLocaux1',
  'volailles, lapins et produits dérivés': 'categoryProdcteurLocaux2',
  oeufs: 'categoryProdcteurLocaux3',
  'fromage, lait et produits laitiers': 'categoryProdcteurLocaux4',
  'fruits et légumes': 'categoryProdcteurLocaux5',
  'farines, fruits et légumes secs': 'categoryProdcteurLocaux6',
  champignons: 'categoryProdcteurLocaux7',
  'epices et huiles': 'categoryProdcteurLocaux8',
  'miel, produits dérivés et confitures': 'categoryProdcteurLocaux9',
  'cidre, bière, jus de fruit et autres boissons': 'categoryProdcteurLocaux10',
  'label "bienvenue à la ferme"': 'V_logo_Ferme',
  'label bio ab': 'V_logo_AB',
};
